import { inject, Injectable } from '@angular/core';
import { ProductCardGroupModalApiService } from "./product-card-group-modal-api.service";
import {
  AttachDetachProductsBodyParams,
  AttachDetachProductsParams,
  GetProductsQueryParams,
  WildberriesProductCardData
} from "../types/product-card-group-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardGroupModalService {
  private productCardGroupModalApiService: ProductCardGroupModalApiService = inject(ProductCardGroupModalApiService);

  public getUnattachedProducts(params: GetProductsQueryParams): Promise<Array<WildberriesProductCardData>> {
    return new Promise<Array<any>>((resolve, reject) => {
      this.productCardGroupModalApiService.fetchUnattachedProducts(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getAttachedProducts(mainArticleId: number): Promise<Array<WildberriesProductCardData>> {
    return new Promise<Array<any>>((resolve, reject) => {
      this.productCardGroupModalApiService.fetchAttachedProducts(mainArticleId).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachProducts(params: AttachDetachProductsParams): Promise<Array<WildberriesProductCardData>> {
    return new Promise<Array<WildberriesProductCardData>>((resolve, reject) => {
      this.productCardGroupModalApiService.attachProducts(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public detachProducts(params: AttachDetachProductsBodyParams): Promise<Array<WildberriesProductCardData>> {
    return new Promise<Array<WildberriesProductCardData>>((resolve, reject) => {
      this.productCardGroupModalApiService.detachProducts(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
